import React, { useEffect } from "react";
import { useAuthenticationConfiguration } from "./Configuration";
import useAuthenticationStore from "./Store";
import { AuthenticationViews } from "./types";
import { useNavigate } from "react-router-dom";
import EnableMfa from "./EnableMfa";

const EnableMfaContainer: React.FC = () => {
    const configuration = useAuthenticationConfiguration();
    const { state, snooze2FA, enableTotp, addPasskey } = useAuthenticationStore();
    const { serverError, isLoading } = state;
    const navigate = useNavigate();

    useEffect(() => {
        if ((!state.totpKey || !state.totpQrCodeUri) && !configuration.passkeyServerBaseUrl) {
            navigate("../" + AuthenticationViews.login);
        }
    }, [state.totpKey, state.totpQrCodeUri, navigate]);

    const addPasskeyHandler = async () => {
        if (!configuration.passkeyServerBaseUrl) return;
        await addPasskey();
    };

    return (
        <EnableMfa
            serverError={serverError}
            isLoading={isLoading}
            allowSnooze={configuration.allowSnooze2FA}
            totpKey={state.totpKey!}
            totpQrCodeUri={state.totpQrCodeUri!}
            snooze2FA={snooze2FA}
            enableTotp={enableTotp}
            passkeysEnabled={!!configuration.passkeyServerBaseUrl}
            addPasskey={addPasskeyHandler}
        />
    );
};

export default EnableMfaContainer;
